

















































export default {
    name: 'ExpiredJobHiredQuestionModal',

    data(){
        return{
          expiredJobs: [],
          candidate: null,
          hired: false,
          error: null,
        }
    },

    computed: {
      remainingJobs(){
        return this.$store.getters['jobs/getExpiredJobs']
      },

      job(){
        return this.remainingJobs[0];
      },

      candidates(){
        return this.job?.applicants.filter((applicant) => applicant.status !== 'Rejected') ?? [];
      }
    },

    mounted() {
      this.getExpiredJobs();
    },

    methods: {
      async getExpiredJobs(){
        await this.$store
            .dispatch('jobs/getCompanyExpiredJobs')
            .then((response) => {
              this.expiredJobs = response;
            })
            .catch((error) => {});
      },

      async submitAnswer(answer){
        if(this.hired && !this.candidate){
           this.error = 'Hired candidate is required.'
        }
        let payload = {
          hired: answer,
          uuid: this.job.uuid,
          candidate_uuid: this.candidate?.uuid ?? null
        }
        if(!this.hired){
          delete payload.candidate_uuid;
        }

        await this.$store
            .dispatch('jobs/answerJobHired', payload)
            .then((response) => {
              this.hired = false;
              this.candidate = null;
              this.error = null;
            })
            .catch((error) => {});
      },

      notHired(){
        this.hired = false;
        this.candidate = null;
        this.submitAnswer(false)
      }
    },
};
